import { HttpHandler } from 'msw'

import { emailSettings } from './emails'

export const settings: HttpHandler[] = [...emailSettings]
